// Success.jsx
import React, { Component } from 'react';
import { Button, Form } from 'semantic-ui-react';

import { withTranslation } from 'react-i18next';
import back from './images/back.svg';

import { zoomIn } from 'react-animations';
import { fadeInRight } from 'react-animations';
import Radium, { StyleRoot } from 'radium';

import Modal from "react-bootstrap/Modal";

const styles = {

    zoomIn: {
        animation: 'x 1s',
        animationName: Radium.keyframes(zoomIn, 'zoomIn')
    }

    ,
    fadeInRight: {
        animation: 'x 1s',
        animationName: Radium.keyframes(fadeInRight, 'fadeInRight')
    }
}

class Success extends Component {


    constructor(props) {
        super(props);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);


        this.state = {
            plansapi_json: [{ "id": 0, "title": { "en": "", "es": "", "fr": "" }, "description": { "en": "", "es": "", "fr": "" }, "plan_detail": { "en": "", "es": "", "fr": "" }, "plan_url": "", "app_url": "", "buy_now": false}],
            show:null

        }
    }

    
    handleClose(id) {
        this.setState({ show: id });
    }

    handleShow(id, e) {
        e.preventDefault();
        this.setState({ show: id });
    }


 
    back = (e) => {
        e.preventDefault();
        this.props.prevStep();

    }

    stopPost = () => {
       
        this.props.stopPost();
       

    }

    newQuote = () => {

        this.props.clearStorage();


    }

    get_plans = (json_all, json_matches, dest, nat, lenofstay, plancat) => {
        const arr = json_matches.filter(d => d.destination.indexOf(parseInt(dest)) !== -1 && d.nationality.indexOf(parseInt(nat)) !== -1 && d.lengthofstay.indexOf(parseInt(lenofstay)) !== -1 && d.plancategoryapi.indexOf(parseInt(plancat)) !== -1);
        const result = arr.map(a => a.plansapi);
        
        var lookup = [];
        for (var i = 0, len = result.length; i < len; i++) {
            for (var z = 0, len1 = result[i].length; z < len1; z++) {

                for (var y = 0, len2 = json_all.length; y < len2; y++) {
                    if (json_all[y].id === result[i][z]) {
                        lookup.push(json_all[y]);
                    }

                }

            }
        }

       
        return lookup

    }

    // React Life Cycle
    componentDidMount() {

        //var self = this;

        const { values } = this.props;

        this.setState({
            
            plansapi_json: this.get_plans(values.plansall_json, values.planmatches_json, values.destination, values.nationality, values.length_of_stay, values.type_of_insurance)
        })

        

///
        const data = JSON.stringify({
            'firstName': values.firstName,
            'lastName': values.lastName,
            'email': values.email,
            'phone': values.phone,
            //'country_of_residency': values.country_of_residency,
            'destination_country': values.destination_country,
            'destination': values.destination,
            'type_of_insurance': values.type_of_insurance,
            'nationality_country': values.nationality_country,
            'nationality': values.nationality,
            'length_of_stay': values.length_of_stay,
            'post': values.post
        });
 
       // console.log('post'+ values.post)  
        fetch('https://www.wellaway.com/en/sony-post-info/', {
        
       
            method: 'POST', // or 'PUT'
            headers: {
                'Content-Type': 'application/json',
                "Accept": "application/json",
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: data,
            mode: 'cors',
            cache: 'default'
        })
            .then((response) => response.json())
            .then((data) => {
               // console.log('Success:', data);
              
               // if (data[0].success !== '')
              
                this.stopPost();
                   
          
               
                
                
            })
            .catch((error) => {
                console.error('Error:', error);
            });


        ///
    }







    render() {
        const { values } = this.props;
        const {t, i18n} = this.props;
        
        return (
            <StyleRoot> 
                <Form id="questionnaire">
                <fieldset style={values.next === '' ? styles.zoomIn : styles.fadeInRight}>

                <div className="col-xl-8 offset-xl-2 mt-5 text-center ">
                        <p className="p-18">5 {t('step.steps')} 5</p>
                        {this.state.plansapi_json.length > 0 &&
                            values.generaltext_json.map((obj) => {


                                return <div key={obj.id} dangerouslySetInnerHTML={{ __html: obj.success[i18n.language] }}></div>
                            })

                        } 

                        {this.state.plansapi_json.length === 0 &&
                                
                                    values.generaltext_json.map((obj) => {


                                        return <div key={obj.id} dangerouslySetInnerHTML={{ __html: obj.nomatches[i18n.language] }}></div>
                                    })

                                

                        } 
                </div>

                <div className="col-xl-8 offset-xl-2 mt-5 align-middle">

                    <div className="row">
                        <div className="col-xl-12 ">
                            <div className="ui list list-group w-100">
                       {this.state.plansapi_json.length > 0 &&

                                            this.state.plansapi_json.map((obj, index, arr) => {

                                            return <React.Fragment key={index}>
                                                <div className="plan h-100">
                                    <div className="row h-100" ><div className="col-5 my-auto">

                                       <h3>{obj.title[i18n.language]}</h3>
                                       <button className="btn btn-sm btn-yellow-sm" onClick={(e) => this.handleShow(index, e)}>
                                        {t('success.quicklook')}
                                          </button>
                                    </div>

                                        <div className="col-7 ">
                                            <div className="float-right">
                                                                
                                                                <a href={obj.plan_detail[i18n.language]} className="btn btn-yellow btn-width" target="_blank" rel="noopener noreferrer">{t('success.plandetails')}</a>
                                                              {
                                                                obj.buy_now === false ?  <a href={obj.app_url} className="btn well_btn btn-width mt-4 mt-md-0" target="_blank" rel="noopener noreferrer">{t('success.requestquote')}</a> : <a href={obj.app_url} className="btn well_btn btn-width mt-4 mt-md-0" target="_blank" rel="noopener noreferrer">{t('success.startquote')}</a>
                                                                }
                                            </div>
                                        </div>
                                    </div>
                                                </div>

                                                

                                                <Modal
                                                    size="lg"
                                                    aria-labelledby="contained-modal-title-vcenter"
                                                    centered
                                                    show={this.state.show === index} onHide={() => this.handleClose('close')}>
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>{obj.title[i18n.language]}</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body><p key={obj.id} dangerouslySetInnerHTML={{ __html: obj.description[i18n.language] }}></p></Modal.Body>
                                                    <Modal.Footer>
                                                        <button className="btn btn-light" onClick={() => this.handleClose('close')}>
                                                            {t('success.close')}
                                                             </button>
                                                       
                                                    </Modal.Footer>
                                                </Modal>
                                                
                                                {
                                                    index === arr.length - 1 ? '' : <hr />
                                                
                                               

                                             }  
                                             
                                            </React.Fragment>   
                                            })

                                              
                                        
                                        }
                                        
                      
                      
                                        <hr />
                       <div className="col-xl-12 text-center">

                           <div className="ui  w-100">
                                                <a href={values.generaltext_json.map((obj) => {

                                                    if (i18n.language ==='en')
                                                        return obj.plan_en 
                                                    else if (i18n.language === 'es')
                                                            return obj.plan_es 
                                                    else if (i18n.language === 'fr')
                                                        return obj.plan_fr 
                                                    else if (i18n.language === 'pt')
                                                        return obj.plan_pt 
                                                    else return obj.plan_en
                                                })

                                                } className="btn btn-yellow_pale btn-width" target="_blank" rel="noopener noreferrer">{t('success.allplans')}</a>

                                                <button className="btn well_btn_pale btn-width"  onClick={this.newQuote} >{t('success.newquote')}</button>
                           
                           </div>

                       </div>

                            </div>
                        </div>

                    </div>
                    <div className="row hidden">
                        <div className="col-3 d-flex align-items-center">
                             <Button onClick={this.back} className="previous previous-arrow mt-5">
                                    <img src={back} alt="back" className="image-flud" />
                                    <p className="p-14 d-none d-md-block "> {t('btn.back')}</p>
                                </Button>
								</div>
								
                        </div>



                    </div>

					
            
           
 
           

                        </fieldset>
                         </Form>
            </StyleRoot>  
        )


    }
}

export default withTranslation()(Success);